<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Let's nominate your fund distribution<br>and repayment accounts</h1>
        <p style="font-size: 20px;">
            Fund Distribution and repayments will be allocated to your primary account<br>
            that receives your majority income. If you have other accounts, you can also<br>
            nominate, in order of preference, which accounts repayment instalments can<br>
            be processed from.</p>
          <form id="form11" autocomplete="off" class="account-container pt-70">
            <input type="hidden" name="loan_number" id="loan_number" value="">
            <div class="account-list row" style="margin: auto; max-width: 600px">
                <div class="col-md-4">
                  <p class="account-1-msg">Fund Distribution to this account</p>
                  <div class="account-item account-item-1 ps-relative">
                    <div class="account-icon"></div>
                    <select name="BankNumber[0][order]" id="select-account-bank-1" class="account-item-input" required>
                        <option value="1" selected='selected'>1</option>
                    </select>
                    <p class="account-item-bank-number"></p>
                  </div>
                  <p class="account-2-msg mx-auto">Primary Account</p>
                  <input type="hidden" name="BankNumber[0][account_number]" id="first_account_number">
                  <input type="hidden" name="BankNumber[0][bsb]" id="first_bsb_number">
                  <input type="hidden" name="BankNumber[0][account_name]" id="first_account_name">
                  <input type="hidden" name="BankNumber[0][bank_name]" id="first_bank_name">
                </div>
                <div class="col-md-4">
                  <p class="account-1-msg visibility-hide">Fund Distribution to this account</p>
                  <div class="account-item other-account-item account-item-2 ps-relative">
                    <div class="account-icon"></div>
                    <select name="BankNumber[1][order]" id="select-account-bank-2" class="account-item-input" required>
                        <!-- <option selected="selected" value="">Select</option> -->
                        <option selected="selected" value="2">2</option>
                        <option value="3">3</option>
                    </select>
                    <p class="account-item-bank-number">
                    </p>
                    <input type="hidden" name="BankNumber[1][account_number]" id="second_account_number">
                    <input type="hidden" name="BankNumber[1][bsb]" id="second_bsb_number">
                    <input type="hidden" name="BankNumber[1][account_name]" id="second_account_name">
                    <input type="hidden" name="BankNumber[1][bank_name]" id="second_bank_name">
                  </div>
                  <p class="account-2-msg mx-auto">Secondary Account</p>
                </div>
                <div class="col-md-4">
                  <p class="account-1-msg visibility-hide">Fund Distribution to this account</p>
                  <div class="account-item other-account-item account-item-3 ps-relative">
                    <div class="account-icon"></div>
                    <select name="BankNumber[2][order]" id="select-account-bank-3" class="account-item-input" required>
                        <!-- <option selected="selected" value="">Select</option> -->
                        <option value="2">2</option>
                        <option value="3" selected="selected">3</option>
                    </select>
                    <p class="account-item-bank-number">
                    </p>
                    <input type="hidden" name="BankNumber[2][account_number]" id="third_account_number">
                    <input type="hidden" name="BankNumber[2][bsb]" id="third_bsb_number">
                    <input type="hidden" name="BankNumber[2][account_name]" id="third_account_name">
                    <input type="hidden" name="BankNumber[2][bank_name]" id="third_bank_name">
                  </div>
                  <p class="account-2-msg mx-auto">Tertiary Account</p>
                </div>
            </div>
            <div class="mt-30">
                <label id="primaryAccount-error" class="error" for="primaryAccount"></label>
                <label id="select-account-bank-1-error" class="error" for="select-account-bank-1"></label>
                <label id="select-account-bank-2-error" class="error" for="select-account-bank-2"></label>
            </div>
        </form>
      </div>
    </div>


    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('introduce-yourself')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('id-verification')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
